var ga_events = {
	subscribe: {
		brand_city: 'newsletter:brand-city-mobile',
		brand: 'Newsletter:brand:mobile',
		// brochure_view: 'newsletter:view-back-cover-mobile',
		home: 'newsletter:general-mobile',
		city_detail: 'newsletter:general-mobile'
	}
};